import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListVendor({
    loading,
    filteredVendors,
    selected,
    setSelected,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Vendor Name</th>
                        <th>Vendor Category Name</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                        <th>Mobile</th>
                        <th>Phone</th>
                        <th>Website</th>
                        <th>Address</th>
                        <th>Country</th>
                        <th>State</th>
                        <th>District</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="14" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredVendors.length > 0 ? (
                        filteredVendors.map((v) => {
                            const isInactive = v.status !== "Active";

                            return (
                                <tr key={v.id} className={isInactive ? "table-secondary" : ""}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="vendorSelect"
                                            checked={selected?.id === v.id}
                                            onChange={() => setSelected(v)}
                                            disabled={v.status !== "Active"}
                                        />
                                    </td>
                                    <td>{v.vendorName}</td>
                                    <td>{v.vendorCategoryName}</td>
                                    <td>{v.firstName}</td>
                                    <td>{v.lastName}</td>
                                    <td>{v.emailId}</td>
                                    <td>{v.mobileNo}</td>
                                    <td>{v.phone}</td>
                                    <td>
                                        <a href={v.website} target="_blank" rel="noreferrer">
                                            {v.website}
                                        </a>
                                    </td>
                                    <td>{v.address}</td>
                                    <td>{v.country}</td>
                                    <td>{v.state}</td>
                                    <td>{v.city}</td>
                                    <td>
                                        <span
                                            className={`badge ${v.status === "Active" ? "bg-success" : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(v.id)}
                                        >
                                            {v.status}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="14" className="text-center py-3">
                                No vendors found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
